/**
 * Resuelve una URL de archivo multimedia asegurando que las rutas relativas
 * (/uploads/...) apunten al dominio backend HTTPS configurado (ej: https://api.smartserv.cl).
 */
export const resolveMediaUrl = (url?: string | null): string => {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('data:') ||
    trimmed.startsWith('blob:')
  ) {
    return trimmed;
  }

  const rawApiUrl = (import.meta.env.VITE_API_URL as string) || '';
  const apiOrigin = rawApiUrl.replace(/\/api\/?$/, '');
  const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;

  return `${apiOrigin}${path}`;
};

/**
 * Resuelve una URL de recurso estático público del Frontend (carpeta public/)
 * asegurando que incluya el BASE_URL configurado en Vite (ej: /pagina_web_bartech/).
 */
export const resolvePublicAssetUrl = (url?: string | null): string => {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('data:') ||
    trimmed.startsWith('blob:')
  ) {
    return trimmed;
  }

  // Si es un archivo subido al backend (/uploads/...), usar resolveMediaUrl
  if (trimmed.startsWith('/uploads/') || trimmed.startsWith('uploads/')) {
    return resolveMediaUrl(trimmed);
  }

  const base = (import.meta.env.BASE_URL as string) || '/';
  const cleanBase = base.endsWith('/') ? base : `${base}/`;
  const cleanPath = trimmed.startsWith('/') ? trimmed.slice(1) : trimmed;

  return `${cleanBase}${cleanPath}`;
};

/**
 * Resuelve una URL para el visor de documentos PDF (ya sea un asset público
 * del frontend o un documento PDF almacenado en el backend).
 */
export const resolvePdfUrl = (url?: string | null): string => {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('data:') ||
    trimmed.startsWith('blob:')
  ) {
    return trimmed;
  }

  if (trimmed.startsWith('/uploads/') || trimmed.startsWith('uploads/')) {
    return resolveMediaUrl(trimmed);
  }

  return resolvePublicAssetUrl(trimmed);
};
